import React, { PureComponent } from "react";
import { getStore, sessionStorageUtil } from "Pub/js/storageUtils";
import platform from "Pub/js/platform";
import defaultIcon from "Pub/js/defaultIcon";
import classNames from "classnames";
import { withQuickLaunchArea } from "../hooks";
const { appIcons } = platform;
const getIconSize = iconType => {
    switch (iconType) {
        case "youth_":
            return 46;
        case "business_":
            /**
             * [NCC-60565]商务风格 小应用图标，由原来的52PX 改为45PX
             */
            return 45;
        case "industry_":
            return 60;
        case "simple_":
            return 40;
        default:
            /**
             * [NCC-41954]工作桌面探索：工作桌面小应用图标改为40px*40px
             * 该需求经刘源确认，只修改默认图标size统一改为40
             */
            // 2011图标改为36
            return 36;
    }
};
/**
 * 小应用生成器
 */
let CreaterForApp = props => {
    let { style, appData, editable } = props;
    const { background_image } = appData;
    let bgImgStyle = {};
    if (background_image) {
        bgImgStyle = {
            backgroundImage: `url(./assets/images/app_bg/${background_image}.jpg)`,
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat'
        }
    }
    const handleClick = () => {
        const newAppData = JSON.parse(JSON.stringify(appData));
        if (newAppData.code) {
            newAppData.menuitemcode = newAppData.code; //传菜单编码
        }
        window.openNew(newAppData);
    }
    return (
        <div
            className={classNames("grid-item isapp", { scale: props.isScale })}
            style={{ ...style, ...bgImgStyle }}
            onClick={!editable ? handleClick : () => { }}
        >
            <AppItem name={appData.name} src={appData.image_src} {...props} />
        </div>
    );
};
// icon类型的小部件
export const AppForIcon = ({ src, iconType }) => {
    // 个性化设置时会传入图标风格
    if (iconType === undefined) {
        iconType = getStore("nccIcon") || "";
    }
    iconType = iconType.length ? iconType + "_" : iconType;
    return (
        <div
            className='app-icon'
            style={{
                backgroundImage: `url(${appIcons && appIcons[iconType + src]
                    ? appIcons[iconType + src]
                    : defaultIcon[iconType]
                        ? defaultIcon[iconType]
                        : defaultIcon["defaultIcon"]
                    })`,
                backgroundSize: "contain",
                backgroundRepeat: 'no-repeat',
                // width: getIconSize(iconType),
                height: 32
            }}
        />
    );
};
// 图片类型的小部件
const AppForImg = ({ src }) => {
    return (
        <div
            className='icon-image'
            style={{
                backgroundImage: `url(${src})`,
                backgroundSize: "contain",
                backgroundRepeat: 'no-repeat',
                backgroundSize: "contain",
                height: 32
            }}
        />
    );
};
// 小部件单元
//包装快速发起区域
@withQuickLaunchArea(props => ({
    isShow: !props.editable && !props.isPreview,
    appData: props.appData
}))
class AppItem extends PureComponent {
    constructor(props) {
        super(props);
    }
    // 小应用生成方法
    createrFun = () => {
        let { src, iconType } = this.props;
        if (src) {
            // 根据 src 是否带有路径区分采用 icon 渲染还是采用图片方式渲染
            if (src.indexOf("/") === -1) {
                return <AppForIcon src={src} iconType={iconType} />;
            } else {
                return <AppForImg src={src} />;
            }
        }
        return null;
    };
    render() {
        let name = this.props.name;
        const { children, displayMode = 'default' } = this.props;
        // 工业风图标不显示小应用背景灰色图片
        let showBackgroundIcon = getStore("nccIcon") == "industry";
        return (
            // 无权限时先展示默认视图，这样可以看到标题
            <div fieldid={`${name}_app-item`} className={`app-item is-app display-${children ? 'default' : displayMode}`}>
                <span className='app-item_title' draggable="true">{name}</span>
                {
                    children && <div style={{ flex: 'auto', position: 'relative' }}>
                        {children}
                    </div>
                }
                <div className='app-content'>
                    {this.createrFun()}
                </div>
            </div>
        );
    }
}
export default CreaterForApp;
